module.exports = __webpack_public_path__ + "15a2f16d71ac4cff246e8b58f6d3446a.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/download-symbol.svg
// module id = tDjL
// module chunks = 1